import React, { useContext, useRef, useState, useEffect } from 'react';
import styled from 'styled-components';
import { Dialog, Item } from '@zebra-fed/zds-react-desktop';
import { SnackbarContent } from "../../styled-components/shared";
import ShowPassword from '../ShowPassword';
import firebaseUtil from '../../data/FirebaseUtil';
import TextField from '@material-ui/core/TextField';
import InputLabel from '@material-ui/core/InputLabel';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Snackbar from '@material-ui/core/Snackbar';
import FormHelperText from '@material-ui/core/FormHelperText';
import config from '../../data/application.properties'
import '@zebra-fed/icons/Alert/index.css';
import { useTranslation } from "react-i18next";
import { MessageResponseContext } from "../../data/MessageLocalizationProvider";
//import Autocomplete from '@material-ui/lab/Autocomplete';
import DropdownCustom from '../DropdownCustom';
import Alert from '@material-ui/lab/Alert';

import { AuthContext } from '../../authentication/Auth';
import app from '../../authentication/firebaseStart';
import {USER_TYPE} from '../../data/constants';
var validator = require("email-validator");

const firestore = app.firestore();

const ModalHeader = styled.div`
    display: flex;
    flex-direction: row;
    height: 50px;
    font-size: 18px;
    background-color: #007ABA;
    color: white;
    align-items: center;
    padding: 0 24px;    
    justify-content: center;
`

const MainContent = styled.div`
  margin-top: 0;
  margin-bottom: 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
`;

const StyledTextField = styled(TextField)`
  width: 220px;
  display: flex;
`;

const ElementWrapper = styled.div`
    display: flex;
    padding-top: 8px;
`;

const RoleSelector = styled(FormControl)`
    width: 220px;
    padding-top: 8px;
`;


export default function ForgotPasswordModal(props) {
    const dialogRef = props.modalRef;
    const { t } = useTranslation();
    const { getKeyItem } = useContext(MessageResponseContext);
    const [checkErrors, setCheckErrors] = useState(false);
    const [snackbarOpen, setSnackbarOpen] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isSSO, setSSO] = useState(false);
    const [showPassword, setShowPassword] = useState(false);
    const [showPasswordConf, setShowPasswordConf] = useState(false);
    //const [sitesArr, setSitesArr] = useState({});
    const errors = useRef([]);
    const serverMessage = useRef('');
    const context = useContext(AuthContext);
    const [allSiteNames, setAllSiteNames] = useState([{ label: "Select Site", value: "" }])
    //console.log('allSiteNames :', allSiteNames);
    const [sitesOld, setSitesOld] = useState([{ label: "Select Site", value: "" }])
    //console.log('sitesOld :', sitesOld);
    //const [siteFilter, setSiteFilter] = useState("")
    //const [resetCusSelect, setResetCusSelect] = useState(false)
    const [sitesFilterVal, setSitesFilterVal] = useState({})
    //const [FilterVal, setFilterVal] = useState({});
    const [siteDefaultValue, setSiteDefaultValue] = useState({ label: "Select Site", value: "" })
    const [filterDefaultValue, setFilterDefaultValue] = useState({});
    const [dataOld, setDataOld] = useState([])
    const string_length = 10
    const [randomPass,setRandomPass] = useState(crypto.randomUUID());

    console.log(allSiteNames, 'allSiteNames')
    const [singleUser, setSingleUser] = useState({
        email: "",
        authType: 0,
        password: randomPass,
        confirmPassword: randomPass,
        role: "None",
        siteName: allSiteNames.length > 0 ? allSiteNames[0].value : ""
    });
    useEffect(() => {
        getSitesData();
        getAppSettings();
        console.log('came')
    }, []);

    async function getAppSettings(){
        let companyID = context.currentUser.claims.companyID;
        console.log("Getting App Settigs");
        let appSettings = (
          await firestore.collection('tenants').doc(companyID).collection('Configuration').doc('AppSettings').get()
        ).data();
        let ssoStatus = appSettings ? appSettings.SSOActivationStatus : false;
        setSSO(ssoStatus);
        let userType = ssoStatus ? USER_TYPE.SSO:USER_TYPE.NON_SSO;
        setSingleUser({...singleUser, userType: userType});
        console.log("IsSSO:"+ isSSO);
        console.log("App Settings:",appSettings);

    }

    function onSubmit() {
        errors.current = [];
        if (singleUser.email.trim() === "" || !validator.validate(singleUser.email)) {
            errors.current = errors.current.concat('email');
        }
        let email = singleUser.email.trim()
        if (email.length > 255) {
            errors.current = errors.current.concat('email length');
        }
        if (singleUser.role === "None") {
            errors.current = errors.current.concat('role');
        }
        if (singleUser.password.trim() === "") {
            errors.current = errors.current.concat('password');
        }
        console.log(singleUser.siteName === "", singleUser.role === "manager", 'sdfsdsdfeteret')
        if (singleUser.role === "manager") {
            if ((!singleUser.siteName || (singleUser.siteName === ""))) {
                console.log('came')
                errors.current = errors.current.concat('sitename');
            }
        }

        /*if (singleUser.password.match("^[A-Za-z0-9!@#$%&]*$") === null) {
            errors.current = errors.current.concat('invalidPassword');
        }*/
        if (singleUser.password !== singleUser.confirmPassword) {
            errors.current = errors.current.concat('password match');
        }
        if (singleUser.password.length < 6) {
            errors.current = errors.current.concat('password length');
        }
        setCheckErrors(!checkErrors); // force rerender
        if (errors.current.length === 0) {
            uploadData();
        }
    };

    function isFieldErrored(field) {
        const isErrored = errors.current.map((error) => error.includes(field));
        return isErrored.includes(true);
    }

    function handleCancel() {
        dialogRef.current.toggleDialog();
        clearForm();
    }

    async function uploadData() {
        setIsLoading(true);
        let dsp = "";
        let companyID = context.currentUser.claims.companyID;
        if (singleUser.role === "manager") {
            if (singleUser.siteName) {
                if (singleUser.siteName !== "Select Site") {
                    let selectedSite = singleUser.siteName.toUpperCase();

                    let myQry = (
                        await firestore
                            .collection('tenants')
                            .doc(companyID)
                            .collection('SiteLocations')
                            .where('siteName', '==', selectedSite)
                            .get()
                    ).docs.map((doc) => doc.data());
                    console.log(myQry, 'myQry');
                    if (myQry.length > 0) {
                        if (myQry[0].displaySiteName)
                            dsp = myQry[0].displaySiteName;
                    }
                }
            }
        }

        if(parseInt(singleUser.userType) === USER_TYPE.NON_SSO ) {
            singleUser.authType = "0";
        }
        else {
            singleUser.authType = "1";
        }


        console.log("Creating User",singleUser);
        let response = await firebaseUtil.createUser(singleUser, dsp, t);
        setIsLoading(false);
        console.log("Add user response ", response);
        if (response.status) {
            props.onClose(response.statusCode);
            clearForm();
            setSitesFilterVal({});
            dialogRef.current.toggleDialog();
        } else {
            //serverMessage.current = getKeyItem(response.msg);
            serverMessage.current = response.msg;
            setSnackbarOpen(true);
        }


    };

    function clearForm() {
        setSingleUser({ email: "", password: randomPass, confirmPassword: randomPass, role: "None" });
        setSitesFilterVal([{ label: "Select Site", value: "" }])
        setShowPassword(false)
        setShowPasswordConf(false)
        setCheckErrors(false);
        setAllSiteNames(sitesOld)
        errors.current = [];
    };

    async function getSitesData() {
        let companyID = context.currentUser.claims.companyID;
        var siteLocations = firestore.collection('tenants').doc(companyID).collection("SiteLocations").limit(10);
        var sitesData = [];

        try {
            var siteLocationsSnapShot = await siteLocations.get();
            var sitesData = [{ label: "Select Site", value: "" }];
            siteLocationsSnapShot.forEach(doc => {
                sitesData.push({ 'label': doc.data().siteName, 'value': doc.data().siteName });
            });
            setAllSiteNames(sitesData);
            setSitesOld(sitesData);
        }
        catch (err) {
            console.log('Error getting documents', err);
        }
    }

    function onFilterChange(e) {
        let opted = e.target.value;
        console.log(opted, 'opted')
        // console.log(sitesOld.includes([{ label: "Select Site", value: "" }]),'exists')
        // if(sitesOld.includes([{ label: "Select Site", value: "" }])) {
        //     sitesOld.unshift({ label: "Select Site", value: "" });
        // }

        console.log(sitesOld, 'sitesOld in onFilterChange')
        //if (opted === 'Select Site') {
        //setData(dataOld)
        //}
        setSitesFilterVal(e.target);
        setAllSiteNames(sitesOld);
        setSingleUser({ ...singleUser, siteName: opted })

        console.log(singleUser, 'singleUser after onFilterChange');
    }

    async function getSelectInputSearch(rawInput, type) {

        try {
            let companyID = context.currentUser.claims.companyID;
            if (type === 'ENTERHIT' && rawInput) {
                let sites = [];
                setIsLoading(true);

                sites = (
                    await firestore
                        .collection('tenants')
                        .doc(companyID)
                        .collection('SiteLocations')
                        .orderBy('siteName')
                        .startAt(rawInput.toUpperCase()).endAt(rawInput.toUpperCase() + "\uf8ff")
                        .limit(10)
                        .get()
                ).docs.map((doc) => doc.data());

                let finalSitesArray = [{ label: "Select Site", value: "" }];
                if (sites.length > 0) {
                    sites.forEach(element => {
                        finalSitesArray.push({ label: element.siteName, value: element.siteName })
                    });
                }
                setAllSiteNames(finalSitesArray)
                setIsLoading(false);
            }
        } catch (err) { console.log(err, 'errorrororo') }



        // if (type === 'ENTERHIT') {
        //     let customFil = allSiteNames.filter(
        //         value => {
        //             return (
        //                 value
        //                     .value
        //                     .toLowerCase() ===
        //                 (rawInput.toLowerCase())
        //             );
        //         });
        //     if (customFil.length === 0) {
        //         searchSiteName(rawInput)
        //     }
        //     else {
        //         setAllSiteNames(customFil)
        //     }
        // } else if (type === 'EMPTY') {
        //     setAllSiteNames(sitesOld)
        // }
    }

    async function searchSiteName(value) {
        let companyID = context.currentUser.claims.companyID;
        let sites = [];
        setIsLoading(true);
        sites = (
            await firestore
                .collection('tenants')
                .doc(companyID)
                .collection('SiteLocations')
                .where('siteName', '==', value.toUpperCase())
                // .orderBy('displaySiteName')
                // .limit(10)
                .get()
        ).docs.map((doc) => doc.data());
        let finalSitesArray = allSiteNames;

        if (sites.length > 0) {
            Object.keys(sites).forEach(site => {
                finalSitesArray.push({ label: sites[site].displaySiteName, value: sites[site].displaySiteName })
            })
            setSitesOld(finalSitesArray)
            setAllSiteNames([{ label: sites[0]?.displaySiteName, value: sites[0]?.displaySiteName }])
            setIsLoading(false);
        } else {
            setAllSiteNames([])
            setIsLoading(false);
        }
    }

    function customFilterSearch(option, rawInput) {
        return allSiteNames;
    }

    /*     function selectOnBlur(e) {
            console.log(e,'e in select On blur')
            let opted = e.target.value;
            setAllSiteNames(sitesOld);
            setSingleUser({ ...singleUser, siteName: opted })
        } */

    const ButtonStyle = {
        cursor: isLoading ? 'wait' : 'pointer',
    }

    console.log(sitesFilterVal, 'sitesFilterVal')
    console.log(sitesFilterVal.label, 'sitesFilterVal label')
    console.log(siteDefaultValue, 'siteDefaultValue')

    return (
        <>
            <Dialog ref={dialogRef}
                key='dialog2'
                width='520px'
                items={[
                    <Item type='button' style={{ ...ButtonStyle, backgroundColor: '#757575', width: '102px' }} onClick={handleCancel} disabled={isLoading}>{t("cancel")}</Item>,
                    <Item type='button' style={ButtonStyle} onClick={onSubmit} disabled={isLoading}>{t('addUser')}</Item>,
                ]}
                headerStyle={{ display: 'none' }}
                bodyStyle={{ padding: '0px', width: '100%' }}
                cardStyle={{ marginBottom: '80px' }}
                style={{ cursor: isLoading ? 'wait' : 'default' }}>
                <ModalHeader>
                    {t('addUserHeading')}
                </ModalHeader>
                <MainContent>
                    <ElementWrapper style={{ paddingTop: '16px' , display: isSSO ? 'block' : 'none' }}>
                        <Alert severity="info">{t('ssoIsActive')} </Alert>
                    </ElementWrapper>
                    <ElementWrapper style={{ paddingTop: '16px' , display: isSSO ? 'none' : 'block' }}>
                        <Alert severity="info">{t('ssoNotActive')} </Alert>
                    </ElementWrapper>
                    <ElementWrapper style={{ paddingTop: '16px' }}>
                        <RoleSelector error={isFieldErrored('role')}>
                            <InputLabel htmlFor="role-selector">Type</InputLabel>
                            <Select
                                native
                                value={singleUser.userType}
                                onChange={(e) => setSingleUser({ ...singleUser, userType: e.target.value })}
                                inputProps={{
                                    name: 'userType',
                                    id: 'userType-selector',
                                }}
                            >
                                <option value={0}>Non SSO</option>
                                <option value={1}>SSO</option>
                            </Select>
                            <FormHelperText>{errors.current.includes('role') ? t('messages.error.err23') : ''}</FormHelperText>
                        </RoleSelector>
                    </ElementWrapper>
                    <ElementWrapper style={{ paddingTop: '16px' }}>
                        <RoleSelector error={isFieldErrored('role')}>
                            <InputLabel htmlFor="role-selector">{t('role')}</InputLabel>
                            <Select
                                native
                                value={singleUser.role}
                                onChange={(e) => setSingleUser({ ...singleUser, role: e.target.value })}
                                inputProps={{
                                    name: 'age',
                                    id: 'role-selector',
                                }}
                            >
                                <option value={'None'}>{t('none')}</option>
                                <option value={'admin'}>{t('admin')}</option>
                                <option value={'manager'}>{t('manager')}</option>
                            </Select>
                            <FormHelperText>{errors.current.includes('role') ? t('messages.error.err23') : ''}</FormHelperText>
                        </RoleSelector>
                    </ElementWrapper>
                    <ElementWrapper >
                        <StyledTextField
                            error={isFieldErrored('email')}
                            label={t('email')}
                            value={singleUser.email}
                            onChange={(e) => setSingleUser({ ...singleUser, email: e.target.value })}
                            type="email"
                            autoComplete="email"
                            helperText={errors.current.includes('email') ? t('validation.rules.email') :// config.EMAIL_RULES
                            errors.current.includes("email length") ? t('messages.error.err22') : null}
                        />
                    </ElementWrapper>
                    <ElementWrapper style={{ display: 'none' }}>
                        <StyledTextField
                            error={isFieldErrored('password')}
                            label={t('password')}
                            value={singleUser.password}
                            onChange={(e) => setSingleUser({ ...singleUser, password: e.target.value })}
                            type={showPassword ? "text" : "password"}
                            autoComplete="new-password"
                            helperText={
                                errors.current.includes('password') ? t('validation.rules.password') :
                                    errors.current.includes('password length') ? t('messages.error.err24') :
                                        errors.current.includes('invalidPassword') ? t('validation.rules.passwordValidation3') : ''
                            }
                            InputProps={{
                                endAdornment: <ShowPassword showPassword={showPassword} onClick={() => setShowPassword(!showPassword)} size={25} />
                            }}
                        />
                    </ElementWrapper>
                    <ElementWrapper style={{ display: 'none' }}>
                        <StyledTextField
                            error={errors.current.includes('password match')}
                            label={t('confirmPassword')}
                            value={singleUser.confirmPassword}
                            onChange={(e) => setSingleUser({ ...singleUser, confirmPassword: e.target.value })}
                            type={showPasswordConf ? "text" : "password"}
                            autoComplete="new-password"
                            helperText={errors.current.includes('password match') ? t('messages.error.err25') : null}
                            InputProps={{
                                endAdornment: <ShowPassword showPassword={showPasswordConf} onClick={() => setShowPasswordConf(!showPasswordConf)} size={25} />
                            }}
                        />
                    </ElementWrapper>
                    <ElementWrapper style={{ display: singleUser.role === "manager" ? "flex" : "none" }}>
                        <RoleSelector error={isFieldErrored('sitename')}>
                            <div className="AddUsersDropdown" >
                                <DropdownCustom
                                    selectOpts={allSiteNames}
                                    onChange={(e) => onFilterChange(e)}
                                    selectVal={sitesFilterVal.label ? sitesFilterVal : siteDefaultValue}
                                    isSearchable={true}
                                    onSearchInpChange={getSelectInputSearch}
                                    isLoading={isLoading}
                                    customFilterOption={customFilterSearch}
                                    changeHeight={true}
                                //selectOnBlur={(e) => selectOnBlur(e)}
                                />
                            </div>
                            <FormHelperText>{errors.current.includes('sitename') ? t('messages.error.err123') : ''}</FormHelperText>
                        </RoleSelector>

                    </ElementWrapper>



                </MainContent>
                <Snackbar open={snackbarOpen} autoHideDuration={3000} onClose={() => setSnackbarOpen(false)}>
                    <SnackbarContent error={true}>{serverMessage.current}</SnackbarContent>
                </Snackbar>
            </Dialog>
        </>
    )
}